import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { setMark } from '@eb/performance-monitor';

import ConnectedFeedBuilder from './ConnectedFeedBuilder';
import ConnectedLocationSearchAutocomplete from './ConnectedLocationSearchAutocomplete';

import { fetchEventsForTab } from '../redux/events/actions';

import { ALL_TAB, FEED_TABS, FOR_YOU } from '../constants/tabConfig';
import {
    EVENT_SEARCH_PROPTYPES,
    LOCATION_PROP_TYPE,
} from '../constants/propTypes';
import { BASE_SEASONAL_CONTENT_PROPTYPES } from '../constants/seasonal';
import { inyectSeasonalTab } from '../utils/seasonal';
import { scrollIt } from '../utils/random';

import { gettext } from '@eb/i18n';

import StickyTabs from '../components/StickyTabs';

import './BrowseContainer.scss';

const LOCATION_AUTOCOMPLETE_PROPS = {
    borderType: 'none',
    id: 'locationPicker',
    name: 'locationPicker',
    hideOutline: true,
    isLimitedSearch: true,
    preventInputValuePrefill: true,
    shouldRemoveConflictiveAria: true,
};

const getBrowseTabs = (shouldShowForYouTab, seasonalContent) => {
    const tabsConfig = inyectSeasonalTab(seasonalContent);
    const tabs = [];

    FEED_TABS.forEach((tabKey, index) => {
        const shouldAddTab =
            tabsConfig[tabKey] &&
            (tabKey !== FOR_YOU || (shouldShowForYouTab && tabKey === FOR_YOU));

        if (shouldAddTab) {
            const { name, eventSearch, follow, feedConfig } = tabsConfig[
                tabKey
            ];

            tabs.push({
                tabKey,
                value: index,
                displayName: name,
                content: (
                    <ConnectedFeedBuilder
                        feedConfig={feedConfig}
                        eventSearch={eventSearch}
                        follow={follow}
                    />
                ),
            });
        }
    });

    return tabs;
};

const getLocationComponent = () => (
    <div className="browse__location eds-l-pad-top-4">
        <div className="browse__location-text">{gettext('Popular in ')}</div>
        <ConnectedLocationSearchAutocomplete
            autocompleteProps={LOCATION_AUTOCOMPLETE_PROPS}
            shouldDispatchSearchActions={true}
        />
    </div>
);

class Browse extends Component {
    static propTypes = {
        fetchEventsForTab: PropTypes.func,
        eventSearch: EVENT_SEARCH_PROPTYPES,
        isAuthenticated: PropTypes.bool,
        tabKey: PropTypes.string,
        shouldShowForYouTab: PropTypes.bool,
        location: LOCATION_PROP_TYPE,
        seasonalContent: PropTypes.arrayOf(
            PropTypes.shape(BASE_SEASONAL_CONTENT_PROPTYPES),
        ),
        isFeLoading: PropTypes.bool,
    };

    componentDidMount() {
        setMark('feed-tabs-ready');
    }

    _handleTabLoad = (tabKey) => {
        const { fetchEventsForTab, isFeLoading } = this.props;

        /**
         * On first load we do not need to fetch new events ONLY for the all_tab.
         * The tab is loaded before the `fe` has finished fetching so we use that
         * variable to know if we are in the all tab to prevent fetching.
         */
        if ((!isFeLoading && tabKey === ALL_TAB) || tabKey !== ALL_TAB) {
            fetchEventsForTab({ tabKey, shouldUpdateContent: true });
        }
    };

    _handleTabChange = (tabKey) => {
        const { fetchEventsForTab } = this.props;

        scrollIt(document.querySelector('.browse-section').offsetTop + 70);

        fetchEventsForTab({ tabKey, shouldUpdateContent: true });
    };

    render() {
        const {
            shouldShowForYouTab,
            tabKey,
            location,
            seasonalContent,
        } = this.props;
        const items = getBrowseTabs(shouldShowForYouTab, seasonalContent);

        const locationComponent = getLocationComponent();

        return (
            <div className="browse-section" id="browse-section">
                {locationComponent}

                <StickyTabs
                    items={items}
                    onTabChange={this._handleTabChange}
                    onTabLoad={this._handleTabLoad}
                    initialSelectedTab={tabKey}
                    location={location}
                />
            </div>
        );
    }
}

const _mapStateToProps = (state) => ({
    isAuthenticated: state.user.isAuthenticated,
    tabKey: state.content.browseState.tabKey,
    shouldShowForYouTab: state.app.featureFlags.launchForYouTab,
    isFeLoading: state.app.loadingState.isFeLoading,
    location: state.location,
    seasonalContent: state.content.seasonal,
});

const _mapDispatchToProps = {
    fetchEventsForTab,
};

export default connect(_mapStateToProps, _mapDispatchToProps)(Browse);
